export const PERMISSION_LEVEL: {
    NONE: PermissionLevel
    RESTRICTED: PermissionLevel
    FULL: PermissionLevel
} = {
    NONE: 0,
    RESTRICTED: 1,
    FULL: 2,
}
